<template>
  <div class="manage-menuHeader">
    <div class="manage-menuHeader_item">
      <div class="manage-menuHeader_name manage-menuHeader_name-active">
        <span class="menuHeader-text-size">{{menuName}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "child",
  props: ["menuName"],
  data() {
    return {
    };
  },
  created() {},
  methods() {},
  watch: {
  },
  mounted() {
  },
  methods: {
    urlChange(url) {
      this.$router.push({ path: url });
    }
  },
  computed: {}
};
</script>
<style lang="less" rel="stylesheet/less">
.manage-menuHeader {
  width: 100%;
  // background: #242e40;
  background: rgb(0,133,232);
  width: 200px;
  overflow: auto;
}
.manage-menuHeader_item {
  // margin-bottom: 10px;
  height: 50px;
  line-height: 50px;
}
.manage-menuHeader_name {
  position: relative;
  // background: #242e40;
  color: #fff;
  opacity: 1;
  font-size: 14px;
  font-weight: 800;
  height: 50px;
  line-height: 50px;
  text-align: center;
  cursor: pointer;
}
.manage-menuHeader_name:hover {
  background: rgb(57, 66, 82);
}
.go {
  transform: rotate(-180deg);
  transition: all 0.5s;
}
.aa {
  transition: all 0.5s;
}
.icon-chevron-down-outline {
  position: absolute;
  top: 50%;
  right: 15px;
  height: 20px;
  line-height: 20px;
  margin-top: -10px;
  font-size: 14px;
  cursor: pointer;
}
.manage-menuHeader_child {
  display: flex;
  padding: 5px 20px;
  background: #242e40;
  color: #fff;
  flex-wrap: wrap;
}
.manage-menuHeader_child_item {
  width: 50%;
  height: 22px;
  line-height: 22px;
  margin: 8px 0 2px;
  cursor: pointer;
}
.manage-menuHeader_active {
  color: #292b33 !important;
  background: #fff !important;
  font-weight: 500;
  opacity: 1 !important;
  border-radius: 2px;
  padding: 4 4px !important;
  height: 22px;
  line-height: 22px;
}
.manage-menuHeader_child_item_hover {
  padding: 4 4px !important;
  display: block;
  width: auto;
  text-align: center;
  opacity: 0.8;
}
.manage-menuHeader_child_item_hover:hover {
  display: block;
  background: rgb(57, 66, 82);
  color: #fff;
  font-weight: 500;
  opacity: 1;
  border-radius: 2px;
  padding: 4 4px !important;
  height: 22px;
  line-height: 22px;
}
.menuHeader-text-size {
  font-size: 18px;
  text-align: center;
}
// .plus-icon-enter-active {
//   // transition: opacity 0.5s;
// }
// .plus-icon-enter {
//   // opacity: 0;
//   animation: mymove 0.5s infinite;
// }
// .plus-icon-leave-active {
//   // transition: opacity 0.5s;
// }
// .plus-icon-leave-to {
//   // opacity: 0;
//   animation: mymove 0.5s infinite;
// }
// @keyframes mymove
// {
// from {left:0px;}
// to {left:200px;}
// }

// @-webkit-keyframes mymove /*Safari and Chrome*/
// {
// from {top:0px;}
// to {left:200px;}
// }
</style>


// WEBPACK FOOTER //
// src/components/common/menuHeader.vue